import { getEventStreamForAskPaper } from "helpers/api";
import { getAskPaperEndpointParams } from "helpers/endpointQueryParams";
import { useRouter } from "next/router";
import { useCallback } from "react";
import useStreaming from "./useStreaming";

type UseStreamingForAskPaperProps = {
  enabled: boolean;
  message?: string;
  onSuccess: () => void;
  paperId?: string;
};

const useStreamingForAskPaper = ({
  enabled,
  message,
  onSuccess,
  paperId,
}: UseStreamingForAskPaperProps) => {
  const router = useRouter();

  const queryKey = `ask_paper_${paperId}_${message}`;
  const queryParams = getAskPaperEndpointParams(router.query);

  const getEventSource = useCallback(() => {
    if (!paperId || !message) return;

    const eventSource = getEventStreamForAskPaper(
      paperId,
      message,
      queryParams
    );

    return eventSource;
  }, [paperId, message, queryParams]);

  return useStreaming({
    queryKey,
    onSuccess,
    enabled,
    getEventSource,
  });
};

export default useStreamingForAskPaper;
